// Deployed DEV environment — baked into the bundle at build time via
// angular.json fileReplacements (configuration "development", used by the
// CI dev deploy: `ng build --configuration=development`).
//
// The deployed dev container serves the SPA through nginx, which has NO
// `/api` proxy (unlike local `ng serve` + proxy.conf.json). The API base
// MUST therefore be an absolute URL — the dev service-provider-service
// custom domain, bound SniEnabled with an Azure-managed cert on container
// app "sp-service-api". Routes are served under /api/v1.
//
// NOTE: the dev UI and API are different origins, so the API must allow
// CORS from the UI origin (see sp_cors_origins in the dev terraform).
export const environment = {
  production: false,
  apiBaseUrl:
    "https://dev.api.service-provider.davaco.cloud/api/v1",
  // Masterdata-service backs the lookup dropdowns (e.g. the services catalog).
  masterdataBaseUrl: "https://dev.api.masterdata.davaco.cloud",
  // Apex host for the corporate (AAD) flow; <slug>.<baseHost> selects Auth0.
  baseHost: "dev.service-provider.davaco.cloud",
  // Auth0 (external SP users). Values set per deployment.
  auth0: {
    domain: "davaco-dev.us.auth0.com",
    clientId: "REPLACE_WITH_SPA_CLIENT_ID",
    audience: "https://api.ctv2026.davaco.cloud",
    rolesClaim: "https://davaco.com/roles",
  },
  creatorUrl: "https://dev.creator.davaco.cloud",
  // Which IdP this build authenticates against. Internal instance = "aad".
  authProvider: "aad" as "aad" | "auth0",
  // Azure AD / MSAL configuration. Same tenant as Creator.
  msalConfig: {
    auth: {
      clientId: "c0686805-ff4d-488b-8fc1-b6499a2282d8",
      authority:
        "https://login.microsoftonline.com/20266eb8-0c6e-4253-bbdb-e7db3a9dc961",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  },
  scopes: {
    loginRequest: ["openid", "profile", "email"],
    graph: ["User.Read"],
  },
  apiConfig: {
    // Token requested for the SP API; aud must equal SP_SERVICE_API_AUDIENCE.
    scopes: ["api://8dce1801-8dbf-446b-88da-4cf6463ac80b/access_as_user"],
  },
};
